import payacaLoaderGif from './payaca-loader.gif';

const Loader = () => {
  return (
    <img className="w-[75px]" src={payacaLoaderGif} alt="payaca loading icon" />
  );
};

export default Loader;
